<template>
  <div>
    <Layout/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idPersona" class="form-label">IdPersona</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPersona" name="idPersona" v-model="datoPersona.idPersona" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoPersona.idEmpresa"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresa" class="form-label"> Empresa</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="empresa" name="empresa" v-model="datoPersona.empresa" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEmpresaLOV"
                      title="Buscar Empresas">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idTipoIden" name="idTipoIden" v-model="datoPersona.idTipoIden"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idTipoIden" class="form-label"> Tipo Iden</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="tipoIden" name="tipoIden" v-model="datoPersona.tipoIden" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalTipoIdenLOV"
                      title="Buscar Tipos de Identificación">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idLocalidad" name="idLocalidad" v-model="datoPersona.idLocalidad"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idLocalidad" class="form-label"> Localidad</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="localidad" name="localidad" v-model="datoPersona.localidad" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalLocalidadLOV"
                      title="Buscar Localidades">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEstadoCivil" name="idEstadoCivil" v-model="datoPersona.idEstadoCivil"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEstadoCivil" class="form-label"> Estado Civil</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="estadoCivil" name="estadoCivil" v-model="datoPersona.estadoCivil" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEstadoCivilLOV"
                      title="Buscar Estado Civil">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoPersona.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerNombre" class="form-label">PrimerNombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="primerNombre" name="primerNombre" v-model="datoPersona.primerNombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="segundoNombre" class="form-label">SegundoNombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="segundoNombre" name="segundoNombre" v-model="datoPersona.segundoNombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="primerApellido" class="form-label">PrimerApellido</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="primerApellido" name="primerApellido" v-model="datoPersona.primerApellido" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="segundoApellido" class="form-label">SegundoApellido</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="segundoApellido" name="segundoApellido" v-model="datoPersona.segundoApellido" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaNac" class="form-label">FechaNac</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaNac" name="fechaNac" v-model="datoPersona.fechaNac" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="direccion" class="form-label">Dirección</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="direccion" name="direccion" v-model="datoPersona.direccion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="telefono" class="form-label">Telefono</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="telefono" name="telefono" v-model="datoPersona.telefono" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="tipoPersona" class="form-label">TipoPersona</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="tipoPersona" name="tipoPersona" v-model="datoPersona.tipoPersona" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="sexo" class="form-label">Sexo</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="sexo" name="sexo" v-model="datoPersona.sexo" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="email" class="form-label">Email</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="email" name="email" v-model="datoPersona.email" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoPersona.fechaReg" required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" @click.prevent="cerrarPersona" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarPersona" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditPersona" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdMedico</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdEspecialidad</th>
          <th scope="col">Documento</th>
          <th scope="col">Estado</th>
          <th scope="col">PersonaFechaReg</th>
          <th scope="col">EspecialidadNombre</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="medico in datosPaginados" :key="medico.idMedico">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(medico.idMedico)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(medico.idMedico)" title="Editar">edit_square</i></td>
          <td>{{medico.idMedico}}</td>
          <td>{{medico.idPersona}}</td>
          <td>{{medico.idEspecialidad}}</td>
          <td>{{medico.documento}}</td>
          <td>{{medico.estado}}</td>
          <td>{{getFormattedDate(medico.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{medico.especialidadNombre}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deletePersona(medico.idMedico)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idMedico" class="form-label">IdMedico</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMedico" name="idMedico" v-model="datoMedico.idMedico" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPersona" class="form-label">IdPersona</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPersona" name="idPersona" v-model="datoMedico.idPersona" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <input type="hidden" class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoMedico.idEspecialidad"
                disabled>
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-9">
                    <input type="text" class="form-control" id="especialidad" name="especialidad" v-model="datoMedico.especialidad" disabled>
                  </div>
                  <div class="col-1">
                    <button type="button" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ModalEspecialidadLOV"
                      title="Buscar Especialidad">
                      <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">manage_search</i>
                    </button>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="documento" class="form-label">Documento</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="documento" name="documento" v-model="datoMedico.documento" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
<!--
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
-->
        <button type="submit" class="btn btn-light" @click.prevent="guardarMedico" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMedico" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

<!--
Listas de valores master
-->
<!-- Lista de Valores: Empresa -->
    <EmpresaLOV @DatosEmpresa="GetDataEmpresaLOV($event)"/>
<!-- Lista de Valores: TipoIden -->
    <TipoIdenLOV @DatosTipoIden="GetDataTipoIdenLOV($event)"/>
<!-- Lista de Valores: Localidad -->
    <LocalidadLOV @DatosLocalidad="GetDataLocalidadLOV($event)"/>
<!-- Lista de Valores: EstadoCivil -->
    <EstadoCivilLOV @DatosEstadoCivil="GetDataEstadoCivilLOV($event)"/>
<!--
Listas de valores master
-->
<!--
Listas de valores details
-->
<!-- Lista de Valores: Medico -->
    <MedicoLOVdet @DatosMedico="GetDataMedicoLOVdet($event)"/>
<!-- Lista de Valores: Especialidad -->
    <EspecialidadLOVdet @DatosEspecialidad="GetDataEspecialidadLOVdet($event)"/>
<!--
Listas de valores details
-->
    <Footer/>
  </div>
</template>
<script>
import Layout from '@/components/Layout.vue'
import Footer from '@/components/Footer.vue'
import dateFormat from '@/modules/dateFormat.js';
// Listas de valores master
import EmpresaLOV from '../../components/lovs/EmpresaLOV.vue'
import TipoIdenLOV from '../../components/lovs/TipoIdenLOV.vue'
import LocalidadLOV from '../../components/lovs/LocalidadLOV.vue'
import EstadoCivilLOV from '../../components/lovs/EstadoCivilLOV.vue'
// Listas de valores master
// Listas de valores details
import MedicoLOVdet from '../../components/lovs/MedicoLOV.vue'
import EspecialidadLOVdet from '../../components/lovs/EspecialidadLOV.vue'
// Listas de valores details
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Layout, Footer
// Listas de valores master
, EmpresaLOV
, TipoIdenLOV
, LocalidadLOV
, EstadoCivilLOV
// Listas de valores master
// Listas de valores details
, MedicoLOVdet
, EspecialidadLOVdet
// Listas de valores details
  },
  data () {
    return {
// Variables master
      personas : [],
      datoPersona : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idPersona: '',
// Variables master
// Variables details
      medicos : [],
      datoMedico : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idPersona = this.$route.params.p_idpersona
    this.abrirEditar(this.p_idPersona)
    this.getMedicos()
    this.getDataPagina(this.paginaActual)
  },
  methods : {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
// Procedimientos master
    validarForm(){
      if(this.datoPersona.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.idEmpresa === ''){
        swal("Error!", "El elemento idEmpresa no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.idTipoIden === ''){
        swal("Error!", "El elemento idTipoIden no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.idLocalidad === ''){
        swal("Error!", "El elemento idLocalidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.idEstadoCivil === ''){
        swal("Error!", "El elemento idEstadoCivil no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.documento === ''){
        swal("Error!", "El elemento documento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.primerNombre === ''){
        swal("Error!", "El elemento primerNombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.segundoNombre === ''){
        swal("Error!", "El elemento segundoNombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.primerApellido === ''){
        swal("Error!", "El elemento primerApellido no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.segundoApellido === ''){
        swal("Error!", "El elemento segundoApellido no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.fechaNac === ''){
        swal("Error!", "El elemento fechaNac no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.direccion === ''){
        swal("Error!", "El elemento direccion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.telefono === ''){
        swal("Error!", "El elemento telefono no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.tipoPersona === ''){
        swal("Error!", "El elemento tipoPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.sexo === ''){
        swal("Error!", "El elemento sexo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.email === ''){
        swal("Error!", "El elemento email no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoPersona.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarPersona(){
      if(this.validarForm() === 1){
        try {
          this.datoPersona.idEmpresa = window.sessionStorage.getItem("idEmpresa");
          await api.post('/personas', this.datoPersona)
          swal("Correcto!", "Persona creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditPersona(){
      if(this.validarForm() === 1){
        try {
          await api.post('/personas', this.datoPersona)
          swal("Correcto!", "Persona creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoPersona={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idPersona){
      this.modalWindow = true
      if(idPersona != null){    
           api.get('/vwpersonas/'+idPersona).then(resp=>{
          this.datoPersona = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarPersona(){
      this.$router.push('/Persona')
    },
// Procedimientos master
// Procedimientos detalle
    async getMedicos() {
      const resp = await api.get('/medicos')
      this.medicos = resp.data
    },
    totalPaginas(){
      return Math.ceil(this.medicos.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwmedicos/nombre/'+this.nombreBusqueda).then(response=>{
          this.medicos=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.medicos.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwmedicos').then(response=>{
      this.medicos=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.medicos.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      if(this.datoMedico.idPersona === ''){
        swal("Error!", "El elemento idPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.idEmpresa === ''){
        swal("Error!", "El elemento idEmpresa no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.idTipoIden === ''){
        swal("Error!", "El elemento idTipoIden no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.idLocalidad === ''){
        swal("Error!", "El elemento idLocalidad no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.idEstadoCivil === ''){
        swal("Error!", "El elemento idEstadoCivil no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.documento === ''){
        swal("Error!", "El elemento documento no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.primerNombre === ''){
        swal("Error!", "El elemento primerNombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.segundoNombre === ''){
        swal("Error!", "El elemento segundoNombre no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.primerApellido === ''){
        swal("Error!", "El elemento primerApellido no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.segundoApellido === ''){
        swal("Error!", "El elemento segundoApellido no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.fechaNac === ''){
        swal("Error!", "El elemento fechaNac no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.direccion === ''){
        swal("Error!", "El elemento direccion no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.telefono === ''){
        swal("Error!", "El elemento telefono no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.tipoPersona === ''){
        swal("Error!", "El elemento tipoPersona no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.sexo === ''){
        swal("Error!", "El elemento sexo no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.email === ''){
        swal("Error!", "El elemento email no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.fechaReg === ''){
        swal("Error!", "El elemento fechaReg no puede ser nulo.", "error");
        return 0;
      }
      if(this.datoMedico.estado === ''){
        swal("Error!", "El elemento estado no puede ser nulo.", "error");
        return 0;
      }
      return 1;
    },
    async guardarMedico(){
      if(this.validarForm() === 1){
        try {
          this.datoMedico.idPersona = this.datoPersona.idPersona;
          await api.post('/medicos', this.datoMedico)
          this.getMedicos();
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Medico creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMedico(){
      if(this.validarForm() === 1){
        try {
          await api.post('/medicos', this.datoMedico)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Medico creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoMedico={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idMedico){
      this.modalWindow = true
      if(idMedico != null){    
           api.get('/vwmedicos/'+idMedico).then(resp=>{
          this.datoMedico = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idMedico){
      this.modalWindow = true
      if(idMedico != null){
        this.$router.push('/medicomd/'+idMedico)
      }
    },
    async deleteMedico (idMedico) {
      try{
        await api.delete('/medicos/'+idMedico)
          this.getMedicos()
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
// Listas de valores master
//    Lista de Valores
    GetDataEmpresaLOV(data) {
      this.datoPersona.idEmpresa = data.idEmpresa;
      this.datoPersona.empresa = data.nombre;
    },
//    Lista de Valores
    GetDataTipoIdenLOV(data) {
      this.datoPersona.idTipoIden = data.idTipoIden;
      this.datoPersona.tipoIden = data.nombre;
    },
//    Lista de Valores
    GetDataLocalidadLOV(data) {
      this.datoPersona.idLocalidad = data.idLocalidad;
      this.datoPersona.localidad = data.nombre;
    },
//    Lista de Valores
    GetDataEstadoCivilLOV(data) {
      this.datoPersona.idEstadoCivil = data.idEstadoCivil;
      this.datoPersona.estadoCivil = data.nombre;
    },
// Listas de valores master
// Listas de valores details
//    Lista de Valores
    GetDataMedicoLOVdet(data) {
      this.datoMedico.idMedico = data.idMedico;
      this.datoMedico.medico = data.nombre;
    },
//    Lista de Valores
    GetDataEspecialidadLOVdet(data) {
      this.datoMedico.idEspecialidad = data.idEspecialidad;
      this.datoMedico.especialidad = data.nombre;
    },
// Listas de valores details
  },
}
</script>
